import { SHStack, SHTypography } from "@components/design-systems";
import { WarningSVG } from "@components/svgs";
import { DELAY_TIME } from "@constants";
import { Tooltip, tooltipClasses, useTheme } from "@mui/material";
import shadows from "@mui/material/styles/shadows";
import { hexToRGBA } from "@utils";

export const MSSmallSampleWarningIcon = () => {
  const { palette } = useTheme();
  return (
    <Tooltip
      title={
        <SHStack
          sx={{
            p: 1,
            mt: "3px",
            maxWidth: "1000px",
            minHeight: "20px",
            bgcolor: hexToRGBA(palette.common.white, 0.85),
            border: "1px solid #E3E3E3",
            backdropFilter: "blur(2px)",
            borderRadius: "3px",
            boxShadow: shadows[1],
            position: "relative",
          }}
        >
          <SHTypography>Caution: Small sample. Results based on less than 3 years of data</SHTypography>
        </SHStack>
      }
      enterDelay={DELAY_TIME}
      enterNextDelay={DELAY_TIME}
      placement="top"
      slotProps={{
        popper: {
          sx: {
            [`& .${tooltipClasses.tooltip}`]: {
              backgroundColor: "transparent",
              paddingRight: "0px",
            },
            [`&.${tooltipClasses.popper}[data-popper-placement*="top"] .${tooltipClasses.tooltip}`]:
              {
                marginBottom: "2px",
              },
          },
        },
      }}
    >
      <SHStack mt={"1px"}>
        <WarningSVG backgroundColor={palette.warning[50]} iconColor="white" />
      </SHStack>
    </Tooltip>
  );
};
